import CodeIcon from "@mui/icons-material/Code";
import StorageIcon from "@mui/icons-material/Storage";
import LayersIcon from "@mui/icons-material/Layers";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import WebIcon from "@mui/icons-material/Web";
import BuildIcon from "@mui/icons-material/Build";

export const GetTechIcon = ({ tech }) => {
  if (!tech) return <BuildIcon />;

  const normalizedTech = tech.toLowerCase();

  const iconMap = {
    frontend: <WebIcon />,
    backend: <StorageIcon />,
    fullstack: <LayersIcon />,
    mobile: <PhoneIphoneIcon />,
    "ai/ml": <SmartToyIcon />,
    aiml: <SmartToyIcon />,
    devops: <BuildIcon />,
  };

  return iconMap[normalizedTech] || <CodeIcon />;
};
